import React, { useEffect } from 'react';
import type { Player } from '../types';

interface PlayerRandomizerProps {
  candidates: Player[];
  onComplete: (player: Player) => void;
  onClose: () => void;
}

const PlayerRandomizer: React.FC<PlayerRandomizerProps> = ({ candidates, onComplete, onClose }) => {
  useEffect(() => {
    if (candidates.length === 0) {
      onClose();
      return;
    }

    const randomIndex = Math.floor(Math.random() * candidates.length);
    const selectedPlayer = candidates[randomIndex];

    // Immediately complete and close to keep the interaction snappy
    onComplete(selectedPlayer);
    onClose();
  }, [candidates, onClose, onComplete]);

  return null;
};

export default PlayerRandomizer;
